// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d3gczT544NG32x {\n  border: 1px solid #DFE1E6;\n  box-sizing: border-box;\n  border-radius: 3px;\n  clear: both;\n  display: block;\n  max-height: 500px;\n  max-width: 500px;\n  margin: 8px 0 4px;\n}\n.d3gczT544NG32x._3dP7UHQ1A6jMCs {\n  max-height: 300px;\n  max-width: 23%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachmentImagePreview": "d3gczT544NG32x",
	"modCompactImagePreview": "_3dP7UHQ1A6jMCs"
};
export default ___CSS_LOADER_EXPORT___;
